import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the DataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DataProvider {
  public menu: boolean = false;
  public username: string;
  public role: string;
  public projname: string;

  constructor(public http: HttpClient) {
    console.log('Hello DataProvider Provider');
  }
  

}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts